module.exports = __webpack_public_path__ + "img/pv.23744c1c.png";